exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CreateAppointment__wrapper___vrQYV {\n  padding: 25px;\n  background: #efefef;\n}\n\n.CreateAppointment__timePicker___2kXze {\n  width: 100%;\n  display: block;\n}\n\n.CreateAppointment__wrapper___vrQYV input,\n.CreateAppointment__wrapper___vrQYV select {\n  padding: 10px 15px !important;\n  margin-bottom: 15px;\n  border-radius: 0;\n  border: none;\n  -webkit-appearance: none;\n  line-height: 30px;\n  height: auto !important;\n  width: 100%;\n  color: #000000;\n  font-size: 16px;\n}\n\n.CreateAppointment__wrapper___vrQYV input.CreateAppointment__checkbox___11dv_ {\n  -webkit-appearance: checkbox;\n  display: inline-block;\n  width: 20px;\n}\n\n.CreateAppointment__lastDate___3Jnca {\n  display: block;\n  margin-bottom: 20px;\n  margin-top: -10px;\n  font-size: 13px;\n}\n\n.CreateAppointment__wrapper___vrQYV button {\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "CreateAppointment__wrapper___vrQYV",
	"timePicker": "CreateAppointment__timePicker___2kXze",
	"checkbox": "CreateAppointment__checkbox___11dv_",
	"lastDate": "CreateAppointment__lastDate___3Jnca"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/CreateAppointment/CreateAppointment.css
// module id = 472
// module chunks = 0